export default "/static/build/unionpay.png";